"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var moment = require("moment");
var Types_1 = require("../../../../../Types");
var Services_1 = require("../../../../../Services");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var Components_1 = require("../Components");
var ReportGenerator = /** @class */ (function () {
    function ReportGenerator() {
    }
    ReportGenerator.getReport = function (elem, id, resources, onExpand) {
        if (elem.isSinglePackResult) {
            var requestData = {};
            elem.packs && elem.packs.length && elem.packs.map(function (el) {
                requestData = {
                    id: id,
                    serialNumber: React.createElement("span", { style: { textDecoration: "underline", cursor: "pointer" }, onClick: function () { Services_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.PackDetailsInformationEvent(resources, elem, el)); } }, el.serialNumber),
                    submissionTime: moment(elem.additionalInfo.submitTime && new Date(elem.additionalInfo.submitTime)).format("L LT"),
                    action: elem.additionalInfo.action,
                    RAG: Components_1.HistoryRagIcon.getRagSingle(el),
                    UPRC: el.uprc && React.createElement("div", { style: { display: "flex", justifyContent: "space-evenly" } },
                        React.createElement(Components_1.HistoryUprcIcon, { uprc: el.uprc }),
                        React.createElement(Components_1.CopyText, { copyTarget: el.uprc, resources: resources })) || React.createElement("div", null)
                };
            });
            return requestData;
        }
        else {
            var requestData = {
                id: id,
                serialNumber: React.createElement("span", { style: { cursor: "pointer" }, onClick: function () { onExpand(); } },
                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "mr-2", icon: free_solid_svg_icons_1.faPlusCircle }),
                    elem.additionalInfo.action,
                    " (",
                    elem.packs.length,
                    ")"),
                submissionTime: moment(elem.additionalInfo.submitTime && new Date(elem.additionalInfo.submitTime)).format("L LT"),
                action: elem.additionalInfo.action,
                RAG: Components_1.HistoryRagIcon.getRagMultiple(elem.packs),
                UPRC: React.createElement("div", null),
                packs: []
            };
            elem.packs && elem.packs.length && elem.packs.map(function (el) {
                var _a;
                (_a = requestData.packs) === null || _a === void 0 ? void 0 : _a.push({
                    serialNumber: React.createElement("span", { style: { textDecoration: "underline", cursor: "pointer" }, onClick: function () { Services_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.PackDetailsInformationEvent(resources, elem, el)); } }, el.serialNumber),
                    submissionTime: "",
                    action: "",
                    RAG: Components_1.HistoryRagIcon.getRagSingle(el),
                    UPRC: el.uprc && React.createElement("div", { style: { display: "flex", justifyContent: "space-evenly" } },
                        React.createElement(Components_1.HistoryUprcIcon, { uprc: el.uprc }),
                        React.createElement(Components_1.CopyText, { copyTarget: el.uprc, resources: resources })) || React.createElement("div", null)
                });
            });
            return requestData;
        }
    };
    return ReportGenerator;
}());
exports.ReportGenerator = ReportGenerator;
//# sourceMappingURL=ReportGenerator.js.map